<template>
  <path 
    d="M27.4043 2.96379C27.2499 2.41283 26.949 1.91403 26.5337 1.5204C26.1067 1.11467 25.5834 0.824435 25.0131 0.677101C22.8787 
    0.114522 14.3275 0.114523 14.3275 0.114523C10.7626 0.0739631 7.19855 0.252354 3.65552 0.648688C3.0852 0.806907 2.56282 
    1.10362 2.13485 1.51245C1.71434 1.91705 1.40975 2.41598 1.25064 2.96265C0.868416 5.02174 0.682708 7.11249 0.696014 9.20671C0.682376
    11.299 0.867629 13.3891 1.25064 15.4508C1.40634 15.9952 1.70979 16.4918 2.13144 16.893C2.55309 17.2942 3.07817 17.584 3.65552 
    17.7374C5.81832 18.2989 14.3275 18.2989 14.3275 18.2989C17.8969 18.3395 21.4655 18.1611 25.0131 17.7647C25.5834 17.6174 26.1067 
    17.3272 26.5337 16.9214C26.9489 16.5279 27.2494 16.029 27.4032 15.478C27.7954 13.4197 27.9861 11.3281 27.9726 9.23285C28.0021 
    7.12869 27.8116 5.02722 27.4043 2.96265V2.96379ZM11.6089 13.0982V5.31639L18.7235 9.20784L11.6089 13.0982Z"
  />
</template>

<script>
export default {

}
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
        stroke: var(--iconBorderColor)
    }
</style>